import { useSuspenseQuery } from '@tanstack/react-query'

import { GetEmpreendimentoFotosService } from '@/features/empreendimentos/shared/http/get-empreendimento-fotos.service'
import { GetEmpreendimentoPlantasService } from '@/features/empreendimentos/shared/http/get-empreendimento-plantas.service'

type MidiaTipo = 'fotos' | 'plantas'

export const useEmpreendimentoMidias = (idExterno: number, midiaTipo: MidiaTipo) => {
  return useSuspenseQuery({
    queryKey: ['empreendimento', idExterno, midiaTipo],
    select: (response) => response.data,
    queryFn: () => {
      if (midiaTipo === 'fotos') return new GetEmpreendimentoFotosService().execute(idExterno)
      return new GetEmpreendimentoPlantasService().execute(idExterno)
    },
  })
}
